export { default } from './IconLoading'
